import Divider from 'components/shared/Divider/Divider';

import AuthorizationApplied from '../AuthorizationApplied';
import CardOnFile from '../CardOnFile';

import ChargeLimit from './ChargeLimit';

const InNetwork = ({ phase, onChange }) => {
  return (
    <div className="flex flex-col gap-4">
      <CardOnFile
        value={phase?.card_on_file?.route_to}
        onChange={(route_to) => onChange({ card_on_file: { route_to } })}
      />
      <Divider />
      <AuthorizationApplied
        value={phase?.authorization_applied?.route_to}
        onChange={(route_to) => onChange({ authorization_applied: { route_to } })}
      />
      <Divider />
      <ChargeLimit
        value={phase?.charge_limit}
        onChange={(next) => onChange({ charge_limit: next })}
      />
    </div>
  );
};

export default InNetwork;
